"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRoleInsUserViewModel = instanceOfRoleInsUserViewModel;
exports.RoleInsUserViewModelFromJSON = RoleInsUserViewModelFromJSON;
exports.RoleInsUserViewModelFromJSONTyped = RoleInsUserViewModelFromJSONTyped;
exports.RoleInsUserViewModelToJSON = RoleInsUserViewModelToJSON;
exports.RoleInsUserViewModelToJSONTyped = RoleInsUserViewModelToJSONTyped;
/**
 * Check if a given object implements the RoleInsUserViewModel interface.
 */
function instanceOfRoleInsUserViewModel(value) {
    return true;
}
function RoleInsUserViewModelFromJSON(json) {
    return RoleInsUserViewModelFromJSONTyped(json, false);
}
function RoleInsUserViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ugNo': json['ugNo'] == null ? undefined : json['ugNo'],
        'selectedUNos': json['selectedUNos'] == null ? undefined : json['selectedUNos'],
    };
}
function RoleInsUserViewModelToJSON(json) {
    return RoleInsUserViewModelToJSONTyped(json, false);
}
function RoleInsUserViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ugNo': value['ugNo'],
        'selectedUNos': value['selectedUNos'],
    };
}
